import SkeletonElement from "./SkeletonElement";

type SectionHeadingSkeletonProps = {
  className?: string;
};

export default function SectionHeadingSkeleton({ className = "" }: SectionHeadingSkeletonProps) {
  return (
    <div className={`pt-12 pb-5 ${className}`} data-testid="section-heading-skeleton">
      <SkeletonElement width="w-1/4" height="h-6" className="mb-2" />
      <SkeletonElement width="w-2/3" height="h-4" />
    </div>
  );
}
